import { render } from "./PaymentOptionModal.vue?vue&type=template&id=947935da&scoped=true"
import script from "./PaymentOptionModal.vue?vue&type=script&lang=js"
export * from "./PaymentOptionModal.vue?vue&type=script&lang=js"

import "./PaymentOptionModal.vue?vue&type=style&index=0&id=947935da&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-947935da"]])

export default __exports__